export default __webpack_public_path__ + "static/media/schema.8a1a6342.graphql";